// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3VbUY","tab":"Tabs_tab__2qaUa","tabActive":"Tabs_tabActive__2ot8T"};